import { MarketGuidePage } from '../../../components/market/MarketGuidePage'
import { getGuidePageProps } from '../../../lib/market-pages'
import content from '../../../data/markets/my/guides/kuala-lumpur/aircond-hp-room-size-guide'

// Generated by scripts/generate-market-pages.mjs. Bump CONTENT_REVIEWED by
// hand when the copy in the content module changes (feeds dateModified).
const CONTENT_REVIEWED = '2026-10-03'

export const getStaticProps = () => getGuidePageProps('my', 'kuala-lumpur', 'aircon', CONTENT_REVIEWED)

export default function Page(props) {
    return <MarketGuidePage {...props} content={content} />
}
